import {Column, Entity, JoinColumn, ManyToOne, OneToMany, OneToOne, PrimaryGeneratedColumn} from "typeorm"
import { Product } from "./Products"
import { AssociatedProductType } from "../../enumerations"

@Entity()
export class AssociatedProduct {

	@PrimaryGeneratedColumn()
  id?: number
  
  @Column()
  quantity?: number

  @ManyToOne(() => Product)
  product?: Product

  @ManyToOne(() => Product, (product) => product.associatedProducts)
  owningProduct?: Product[]

  @Column()
  type?:AssociatedProductType

  included?:boolean

}